<div class="row p-1">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Patient Demographics</h2>
  </div>
</div>

<div class="grid dashboard">
  <form [formGroup]="patientdemoForm" (ngSubmit)="save()" class="col-12">
      <p-panel [header]="" class="col-12">
          <div>
              <h6 class="col-5 md:col-1 blueBar mb-4 pl-3 pr-3 r-2"    style="width: max-content">
                  Patient Details
              </h6>
          </div>
          <div class="col-12 grid mb-5 ml-3">
              <div class="col-4 md:col-2">
                  <p-checkbox name="fullName"
                              value="Y"
                              label="Full Name"
                              formControlName="fullName"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
              <div class="col-4 md:col-2">
                  <p-checkbox name="gender"
                              value="Y"
                              label="Gender"
                              binary="true"
                              formControlName="gender"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
              <div class="col-4 md:col-2">
                  <p-checkbox name="dob"
                              value="Y"
                              label="D.O.B"
                              formControlName="dob"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
              <div class="col-4 md:col-2">
                  <p-checkbox name="age"
                              value="Y"
                              label="Age"
                              formControlName="age"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
              <div class="col-4 md:col-2">
                  <p-checkbox name="mrn"
                              value="Y"
                              label="Mrn"
                              formControlName="mrn"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
          </div>

          <div>
              <h6 class="col-5 md:col-1 blueBar mb-4 pl-3 pr-3 r-2"
                  style="width: max-content">
                  Contact Information
              </h6>
          </div>

          <div class="col-12 grid mb-5 ml-3">
              <div class="col-4 md:col-2">
                  <p-checkbox name="add1"
                              value="Y"
                              label="Address"
                              formControlName="address"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>

              <div class="col-4 md:col-2">
                  <p-checkbox name="homePhone"
                              value="Y"
                              label="Home Phone"
                              formControlName="homePhone"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
              <div class="col-4 md:col-2">
                  <p-checkbox name="mobilePhone"
                              value="Y"
                              label="Mobile Phone"
                              binary="true"
                              formControlName="mobilePhone"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
              <div class="col-4 md:col-2">
                  <p-checkbox name="workPhone"
                              value="Y"
                              label="Work Phone"
                              formControlName="workPhone"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
          </div>



          <div>
              <h6 class="col-5 md:col-1 blueBar mb-4 pl-3 pr-3 r-2"
                  style="width: max-content">
                  Other Information
              </h6>
          </div>

          <div class="col-12 grid mb-5 ml-3">
              <div class="col-4 md:col-2">
                  <p-checkbox name="insuranceCompany"
                              value="Y"
                              label="Insurance Company"
                              formControlName="insuranceCompany"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>

              <div class="col-4 md:col-2">
                  <p-checkbox name="pharmacyName"
                              value="Y"
                              label="Pharmacy Name"
                              formControlName="pharmacyName"
                              binary="true"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
              <div class="col-4 md:col-2">
                  <p-checkbox name="pharmacyPhone"
                              value="Y"
                              label="Pharmacy Phone"
                              binary="true"
                              formControlName="pharmacyPhone"
                              [ngStyle]="{ 'font-size': '15px', 'font-weight': 'bold' }"></p-checkbox>
              </div>
          
          </div>


      </p-panel>
    <div class="card">
        <div class="col-12 md:col-4 mt-1 mb-1 ml-2">
            <button pButton  type="submit" label="Save" icon="pi pi-save" class="p-button-plain buttonWidth-8 fl"></button>
      &nbsp;<button pButton  label="Cancel" icon="pi pi-times" class="p-button-plain buttonWidth-8 fl GreyButton" (click)="backToGlobalMappingSetting()"></button>
        </div>

    </div>
  </form>
</div>
